<template>
  <div>
    <blockquote>
      {{activity.message}}
    </blockquote>
  </div>
</template>
<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true,
    }
  }
}
</script>
